import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDDialog, FDDialogActions,
  FDDialogContent,
  FDDialogTitle,
  FDListItem, FDListItemSecondary,
  FDListItemText, FDPrimaryActionButton, FDPrimaryActionIconButton,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

export const Layout = () => {
  const [open, setOpen] = React.useState(false);
  const { resource } = useMetaLayoutContext();

  return (
    <>
      <FDListItem>
        <FDListItemText
          primaryText={resource.attr('updatedAtDisplayText')}
          secondaryText={resource.attr('authorName')}
        />
        <FDListItemSecondary>
          <FDPrimaryActionIconButton icon={'add'} onClick={() => setOpen(true)} />
        </FDListItemSecondary>
      </FDListItem>
      <FDDialog open={open} onClose={() => setOpen(false)}>
        <FDDialogTitle value={resource.attr('noteSubject')} />
        <FDDialogContent>
          <MetaControlField attr={'content'} />
        </FDDialogContent>
        <FDDialogActions>
          <FDPrimaryActionButton label={'Close'} onClick={() => setOpen(false)} />
        </FDDialogActions>
      </FDDialog>
    </>
  );
};
